import toSnakeCase from 'lodash/snakeCase';

/**
 * Ensures property names are snake_case.
 *
 * @param properties - The properties of the event.
 * @returns The formatted properties.
 * @see https://varsity.atlassian.net/wiki/spaces/ENG/pages/1234501678/Event+Standards
 */
function formatPropertyNames(properties) {
  if (!properties) {
    return;
  }

  const formattedProperties = {};

  Object.keys(properties).forEach((key) => {
    formattedProperties[toSnakeCase(key)] = properties[key];
  });

  return formattedProperties;
}

export default formatPropertyNames;
